// extracted by mini-css-extract-plugin
export default {"main_block":"styles_main_block__h6nNX","main_image":"styles_main_image__rDZ2m","sk_share_buttons":"styles_sk_share_buttons__aTUxy"};